import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-lesson-complete-model',
  templateUrl: './lesson-complete-model.component.html',
  styleUrls: ['./lesson-complete-model.component.css']
})
export class LessonCompleteModelComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

  finishLesson(){
    
  }

}
